<template>
  <general-layout v-if="pageList">
    <template #header>
      <east-operate>
        <template #right>
          类别(网易)：
          <el-select v-model="category" size="mini" style="width: 134px;">
            <el-option value="" label="所有类别"></el-option>
            <el-option
              v-for="(text, value) in CATEGORY_TEXT"
              :key="value"
              :value="value"
              :label="text"
            ></el-option>
          </el-select>
          同步方式：
          <el-select v-model="type" size="mini" style="width: 148px;">
            <el-option value="" label="所有同步方式"></el-option>
            <el-option
              v-for="(text, value) in OPERATION_TYPE_TEXT"
              :key="value"
              :value="value"
              :label="text"
            ></el-option>
          </el-select>
          结果：
          <el-select v-model="result" size="mini" style="width: 104px;">
            <el-option value="" label="所有结果"></el-option>
            <el-option value="true" label="成功"></el-option>
            <el-option value="false" label="失败"></el-option>
          </el-select>
          <el-input
            v-model="inputKeyword"
            placeholder="请输入关键字"
            style="width:240px;"
            size="mini"
          >
            <el-button slot="append" @click="keyword = inputKeyword"
              >搜索</el-button
            >
          </el-input>
          <el-button size="mini" @click="handleReset">显示全部</el-button>
          <el-button size="mini" @click="handleDataSource">源数据</el-button>
        </template>
      </east-operate>
    </template>
    <layui-table :data="pageList.list">
      <layui-table-column
        prop="dn"
        min-width="160"
        label="标识(LDAP)"
      ></layui-table-column>
      <layui-table-column width="100" align="center" label="类别(LDAP)">
        <template slot-scope="scope">
          {{
            scope.row.schema === "group"
              ? "邮件组"
              : schemaTitle(scope.row.schema)
          }}
        </template>
      </layui-table-column>
      <layui-table-column min-width="80" label="同步位置">
        <template slot-scope="scope">
          {{ scope.row.target | toPath }}
        </template>
      </layui-table-column>
      <layui-table-column width="240" label="标识(网易)">
        <template slot-scope="scope">
          <span
            v-if="
              scope.row.category === CATEGORY.Unit ||
                scope.row.category === CATEGORY.Group
            "
          >
            {{ scope.row.identity | toPath }}</span
          >
          <span v-else> {{ scope.row.identity }}</span>
        </template>
      </layui-table-column>
      <layui-table-column width="120" align="center" label="类别(网易)">
        <template slot-scope="scope">
          {{ CATEGORY_TEXT[scope.row.category] }}
        </template>
      </layui-table-column>
      <layui-table-column min-width="140" label="修改内容">
        <template slot-scope="scope">
          <span class="pre-line">{{ scope.row.content }}</span>
        </template>
      </layui-table-column>
      <layui-table-column width="90" label="错误信息">
        <template slot-scope="scope">
          <span class="pre-line">{{ scope.row.error }}</span>
        </template>
      </layui-table-column>
      <layui-table-column width="90" align="center" label="同步时间">
        <template slot-scope="scope">
          {{ scope.row.time | dateFormat("HH:mm:ss") }}
        </template>
      </layui-table-column>
      <layui-table-column width="90" label="同步方式">
        <template slot-scope="scope">
          {{ OPERATION_TYPE_TEXT[scope.row.type] }}
        </template>
      </layui-table-column>
      <layui-table-column width="60" label="结果">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDetail(scope.row)">
            <span v-if="scope.row.result" class="text-success">成功</span>
            <span v-else class="text-danger">失败</span>
          </el-button>
        </template>
      </layui-table-column>
    </layui-table>
    <template #footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="$page.sizes"
        :page-size="size"
        layout="total, sizes, prev, pager, next"
        :total="pageList.total"
      >
      </el-pagination>

      <el-dialog
        title="查看同步源数据"
        width="1200px"
        :close-on-click-modal="false"
        :visible.sync="showDatasource"
      >
        <!-- <a-button type="primary" @click="toggleExpanded">{{
          expanded ? "收起" : "展开"
        }}</a-button> -->

        <el-button
          v-clipboard:copy="clipboardtext"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >复制</el-button
        >
        <json-viewer
          copyable
          :value="dataSource"
          :expand-depth="2"
          boxed
          sort
          :expanded="expanded"
          :key="expanded"
          @copied="onCopy"
        >
        </json-viewer>
      </el-dialog>
    </template>
  </general-layout>
</template>

<script>
import TASK from "@/api/sync/task";
import { mapState } from "vuex";
import { DN_PREFIX } from "@/constant/extensionTask";
import { OPERATION_TYPE, OPERATION_TYPE_TEXT } from "@/constant/operation";
import { CATEGORY, CATEGORY_TEXT } from "@/constant/category";

import _ from "lodash";
export default {
  props: {
    id: [String, Number],
    page: { type: [String, Number], default: 1 }
  },

  data() {
    return {
      category: "",
      type: "",
      result: "",
      keyword: "",
      inputKeyword: "",
      size: this.$page.size,
      pageList: null,
      resetting: false,
      showDatasource: false,
      dataSource: {},
      copyable: {
        copyText: "复制",
        copiedText: "复制成功"
      },
      clipboardtext: "",
      visible: false,
      expanded: false
    };
  },
  computed: {
    ...mapState(["options", "schemas"]),
    schemaTitle: vm => name => vm.schemas.find(s => s.name === name)?.title,
    currentPage: vm => Number(vm.page)
  },
  async created() {
    this.DN_PREFIX = DN_PREFIX;
    this.CATEGORY = CATEGORY;
    this.CATEGORY_TEXT = CATEGORY_TEXT;

    // 等待Store初始化完成
    await this.$store.init;
    if (this.options.sync.showSameAndIgnore) {
      this.OPERATION_TYPE_TEXT = OPERATION_TYPE_TEXT;
    } else {
      this.OPERATION_TYPE_TEXT = _.cloneWith(OPERATION_TYPE_TEXT);
      delete this.OPERATION_TYPE_TEXT[OPERATION_TYPE.Same];
      delete this.OPERATION_TYPE_TEXT[OPERATION_TYPE.Ignore];
    }

    this.fetchData();
  },
  watch: {
    page: "fetchData",
    category: "fetchData",
    type: "fetchData",
    result: "fetchData",
    keyword: "fetchData"
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;
    },

    onCopy() {
      this.$message.success("内容已复制到剪切板！");
    },
    onError() {
      this.$message.error("抱歉，复制失败！");
    },
    async fetchData() {
      if (!this.resetting) {
        let response = await TASK.DETAIL({
          id: this.id,
          page: this.page,
          size: this.size,
          category: this.category,
          type: this.type,
          result: this.result,
          keyword: this.keyword
        });
        if (response.data.state) {
          if (this.currentPage !== response.data.pageList.page) {
            this.$router.push({
              query: { page: response.data.pageList.page }
            });
          } else {
            this.pageList = response.data.pageList;
          }
        }
      }
    },
    handleSizeChange(size) {
      this.size = size;
      this.fetchData();
    },
    handleCurrentChange(page) {
      this.$router.push({
        query: { ...this.$route.query, page }
      });
    },
    handleSearch() {
      this.stime = this.time[0];
      this.etime = this.time[1];
      this.fetchData();
    },
    handleDetail(row) {
      this.$router.push({
        name: "任务详情",
        params: { id: row.id }
      });
    },
    handleReset() {
      this.resetting = true;
      try {
        this.category = "";
        this.type = "";
        this.result = "";
        this.keyword = "";
        this.inputKeyword = "";
        this.$router.push({ query: { page: "1" } });
      } finally {
        this.$nextTick(() => {
          this.resetting = false;
          this.fetchData();
        });
      }
    },
    async handleDataSource() {
      document.getElementsByClassName("jv-button").innerText = "复制";
      let loading = this.$loading({
        lock: true,
        text: "同步源数据获取加载中, 请稍后!",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      let response = await TASK.DATADETAIL({ id: this.id });
      if (response.data.state) {
        this.showDatasource = true;
        this.dataSource = response.data.data;
        this.clipboardtext = JSON.stringify(this.dataSource);
        loading.close();
      } else {
        loading.close();
        this.$message.error("源数据获取异常!");
      }
    }
  }
};
</script>

<style scoped>
.el-date-editor {
  position: relative;
  top: 1px;
  margin-right: 10px;
}
.east-operate .right > div:not(:last-child) {
  margin-right: 10px;
}
span.jv-button {
  width: 30px;
  height: 10px;
  /* background: url("./assets/copy.png"); */
}
</style>
